import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ToastProvider, ToastRegion } from './components/ui/Toast';
import TenantBrandingProvider from './contexts/TenantBrandingProvider';
import { registerDefaultWidgets } from './components/widgets';
import './stores/themeStore'; // Eagerly initialise so dark/light class is set before render
import './styles/tokens.css';
import './styles/reset.css';
import './styles/global.css';
import './styles/expandable.css';
import './styles/forms.css';
import './components/ui/ui.css';
import './modules/elc/styles/elc.css';

registerDefaultWidgets();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TenantBrandingProvider>
          <ToastProvider>
            <App />
            <ToastRegion />
          </ToastProvider>
        </TenantBrandingProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
